import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-pill.css';
import { UitkPillContainerAlignments } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkPillContainer = function (props) {
    var _a;
    var children = props.children, className = props.className, wrap = props.wrap, align = props.align, dataTestId = props.dataTestId;
    var baseClassName = 'uitk-pill-container';
    var wrapperClassName = getClassNameList(baseClassName, className, align && UitkPillContainerAlignments.get(align), (_a = {},
        _a["".concat(baseClassName, "-wrap")] = wrap,
        _a));
    return (React.createElement("div", { className: wrapperClassName, "data-stid": dataTestId }, children));
};
UitkPillContainer.displayName = 'UitkPillContainer';

export { UitkPillContainer };
